import type { BlockEmbed } from 'quill/blots/block';
import Quill from 'quill/core';
import type { BlockEmbedMovedInOptions } from '../types';
import findQuillByBlot from './findQuillByBlot';

export default function moveCaretInBlockEmbed(
  blockEmbed: BlockEmbed,
  movedInOptions: BlockEmbedMovedInOptions,
) {
  const quill = findQuillByBlot(blockEmbed);
  if (!quill) return;
  const index = blockEmbed.offset(blockEmbed.scroll);
  quill.setSelection(index, 1, Quill.sources.USER);

  if ('onMoveIn' in blockEmbed && typeof blockEmbed.onMoveIn === 'function') {
    blockEmbed.onMoveIn(movedInOptions);
  }
}
